import { useState } from "react";
import PropTypes from "prop-types";
import { termsAndConditions } from "../../data/termsAndConditions";

const TermsModal = ({ isOpen, onClose }) => {
  const [language, setLanguage] = useState("am");

  if (!isOpen) return null;

  const terms = termsAndConditions[language];

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className="terms-modal-header">
          <div className="terms-header-content">
            <h2 className="terms-modal-title">{terms.title}</h2>
            <div className="language-switcher">
              <button
                className={`lang-btn ${language === "am" ? "active" : ""}`}
                onClick={() => setLanguage("am")}
                type="button"
              >
                አማርኛ
              </button>
              <button
                className={`lang-btn ${language === "en" ? "active" : ""}`}
                onClick={() => setLanguage("en")}
                type="button"
              >
                English
              </button>
            </div>
          </div>
          <button
            className="terms-close-btn"
            onClick={onClose}
            type="button"
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {/* Modal Body */}
        <div className="terms-modal-body">
          {terms.sections.map((section, index) => (
            <div key={index} className="terms-section">
              <h3 className="terms-section-title">{section.title}</h3>
              <div className="terms-section-content">
                {section.content.split("\n").map(
                  (paragraph, pIndex) =>
                    paragraph.trim() && (
                      <p key={pIndex} className="terms-paragraph">
                        {paragraph.trim()}
                      </p>
                    ),
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Modal Footer */}
        <div className="terms-modal-footer">
          <p className="terms-footer-text">
            {terms.lastUpdated}:{" "}
            {new Date().toLocaleDateString(
              language === "am" ? "am-ET" : "en-US",
            )}
          </p>
          <button className="terms-accept-btn" onClick={onClose} type="button">
            {language === "am" ? "ተረድቻለሁ" : "I Understand"}
          </button>
        </div>
      </div>
    </div>
  );
};

TermsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TermsModal;
